import React from "react"
import {useState} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



async function loginUser(credentials) {
  return fetch('https://api.tydacomm.com/api/user/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  })
    .then(data => data.json())
 }

 const error = (text) => {
  toast.error(text, {
    position: toast.POSITION.TOP_RIGHT
});
};

const success = (text) => {
  toast.success(text, {
    position: toast.POSITION.TOP_RIGHT
});
};




export default function Login(props){
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();


const handleSubmit = async e => {
  e.preventDefault();
  const response = await loginUser({
    email,
    password
  });
  

  if(response.error){
   
    error(response.message);
  }else{
    success(response.message)
    localStorage.setItem('accessToken', response.accessToken);
    window.location.href = "/dashboard";
  }

}



  const myStyle={
    backgroundImage: "url('https://tydacomm.com/wp-content/gallery/portfolio/portfolio-yun00013.jpg')",
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: 800
  };
      return (
        <div class="wrapper"  style={myStyle}>
        <div class="row justify-content-center">  
            <div class="col-xl-5 col-lg-6 col-md-8">
                <section id='loginsec'>
                    
                    <div class="card o-hidden border-0 shadow-lg my-5" style={{opacity:"0.95"}}>
                    <div class="card-body p-0">
                        
                      
                        <div class="row">
                          
                            <div class="col-lg-12">
                                
                                <div class="p-5">
                                  
                                    <div class="text-center">
                                        <h1 class="h3 text-gray-900 mb-4 font-weight-bold">Welcome<br/>
                                        <span style={{fontSize:"15px"}}>(TYDA Energy)</span>
                                        </h1>
                                      
                                    </div>
                                    
                                        <div class="form-group">
                                            <input type="email" class="form-control form-control-user"
                                                id="email"
                                                placeholder="Email"   onChange={e => setEmail(e.target.value)} />
                                        </div>
                                        <div class="form-group">
                                            <input type="password" class="form-control form-control-user"
                                                id="password"
                                                placeholder="Password" onChange={e => setPassword(e.target.value)}/>
                                        </div>
                                      
                                        <button type='submit' class="btn btn-primary btn-user btn-block" id='login-btn' name='login' onClick={handleSubmit}>
                                            Login
                                            <span class="spn text-light" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </span>
                                        </button>
                                  
                                    
                                    
                                    
                                  
                                    
                                </div>
                              
                            </div>
                        </div>
                    </div>
                </div>
              
                </section>

                
            </div>
        </div>
        <ToastContainer />
  </div>
    
          
        )
    
}





 